import { Button as RACButton } from "react-aria-components";
import { paginatorButton } from "./paginatorButton.css";
import { PaginatorButtonProps } from "./types";

const PaginatorButton = ({
  onPress,
  children,
  disabled,
  label,
  variant = "single",
}: PaginatorButtonProps) => (
  <RACButton
    onPress={onPress}
    type="button"
    isDisabled={disabled}
    aria-label={label}
    // TODO: Remove paginatorButton styles and replace appropriately
    className={paginatorButton[variant]}
  >
    {children}
  </RACButton>
);

export default PaginatorButton;
